// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.international-icon[data-v-0bb4e66a] {\r\n  font-size: 22px;\r\n  cursor: pointer;\r\n  vertical-align: -5px!important;\n}\n.el-dropdown[data-v-0bb4e66a]{\r\n  color:#5a5e66;\n}\r\n", ""]);
// Exports
module.exports = exports;
